import { z } from "zod";
/** Public-facing evidence classes (GR-002). */
export const PublicEvidenceClassSchema = z.enum([
    "DIRECT_EVIDENCE",
    "INDIRECT_SIGNAL",
    "INFERENCE",
]);
export function mapReadinessEvidenceKindToPublicClass(kind) {
    if (kind === "IMPORT")
        return "INDIRECT_SIGNAL";
    if (kind === "INFERRED")
        return "INFERENCE";
    return "DIRECT_EVIDENCE";
}
/** Automated external scan findings are direct observations of the public site. */
export function defaultExternalScanEvidenceClass() {
    return "DIRECT_EVIDENCE";
}
//# sourceMappingURL=evidence-class.js.map